<!-- HEADER START -->
<ng-container *ngIf="booking$ | async as booking"> 

<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">
    <ion-title color="secondary" class="ion-text-center header-title">{{ booking.getShopName() }}</ion-title>
    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      <ion-button [routerLink]="['/moj-profil', 'moje-rezervacije', booking.id ]" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>
    </ion-buttons>

    <app-top-right slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>
<!-- HEADER END -->
  
<ion-content>
  <agm-map [zoom]="13" [latitude]="booking.getRootReal().geoPoint.coordinates[1]" [longitude]="booking.getRootReal().geoPoint.coordinates[0]">
    <agm-marker [latitude]="booking.getRootReal().geoPoint.coordinates[1]" [longitude]="booking.getRootReal().geoPoint.coordinates[0]"></agm-marker>
  </agm-map>

</ion-content>

</ng-container>
